<template>
  <v-btn
    v-tooltip="{
      text: isBoxFavorite(box)
        ? t('labels.menu.actions.favorites.remove')
        : t('labels.menu.actions.favorites.add'),
      location: 'top',
      openDelay: 1250,
    }"
    :class="{
      'favourite-icon-visible': isFocused || isActive,
    }"
    :color="isBoxFavorite(box) ? 'primary' : undefined"
    :icon="isBoxFavorite(box) ? 'fas fa-star' : 'far fa-star'"
    size="small"
    variant="text"
    v-bind="$attrs"
    @click.stop.prevent="handleFavoriteClick"
  ></v-btn>
</template>

<script lang="ts" setup>
import { useBoxFavorites } from '@/composables/box/box-favorites'
import type { BoxEntry } from '@deepcloud/api-deep-box'

const props = defineProps({
  box: {
    type: Object as PropType<BoxEntry>,
    default: () => ({}),
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  isFocused: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
const { isBoxFavorite, onBoxAddToFavorites, onBoxRemoveFromFavorites } =
  useBoxFavorites()

function handleFavoriteClick(event: MouseEvent) {
  if (!props.box) return

  if (isBoxFavorite(props.box)) {
    onBoxRemoveFromFavorites(props.box)
  } else {
    onBoxAddToFavorites(props.box)
  }

  // Remove focus from the button after click
  ;(event.currentTarget as HTMLElement).blur()
}
</script>

<style scoped lang="scss">
.v-btn {
  opacity: 0;

  &.favourite-icon-visible,
  &:hover,
  &:focus {
    opacity: 1;
  }
}
</style>
